/* eslint-disable */
import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import { BiCheckCircle, BiError, BiErrorCircle, BiInfoCircle } from 'react-icons/bi'

export const ToastContext = createContext(null)

const TOAST_TITLES = {
  success: 'Success',
  danger: 'Error',
  warning: 'Warning',
  info: 'Info',
}

const TOAST_ICONS = {
  success: BiCheckCircle,
  danger: BiErrorCircle,
  warning: BiError,
  info: BiInfoCircle,
}

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success', // success | danger | warning | info
  })

  const showToastMessage = useCallback((message, type = 'success') => {
    setToast({ show: true, message, type })
  }, [])

  const handleClose = useCallback(() => {
    setToast((prev) => ({ ...prev, show: false }))
  }, [])

  const ToastIcon = TOAST_ICONS[toast.type] || BiInfoCircle
  const value = useMemo(() => ({ showToastMessage }), [showToastMessage])

  return (
    <ToastContext.Provider value={value}>
      {children}

      <ToastContainer position="top-center" className="toast-top-center-fixed">
        <Toast
          show={toast.show}
          onClose={handleClose}
          delay={4000}
          autohide
          className={`uoa-toast uoa-toast--${toast.type}`}
        >
          <Toast.Body className="uoa-toast__body">
            <span className="uoa-toast__icon" aria-hidden="true">
              <ToastIcon />
            </span>
            <div className="uoa-toast__text">
              <strong className="uoa-toast__title">
                {TOAST_TITLES[toast.type] || 'Notification'}
              </strong>
              <span className="uoa-toast__message">{toast.message}</span>
            </div>
            <button
              type="button"
              className="btn-close uoa-toast__close"
              aria-label="Close"
              onClick={handleClose}
            />
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}
